import type {
  PaginationDispatchProps,
  PaginationStateProps,
} from 'components/shared/Blotter/Pagination/Pagination.model';
import { connect } from 'react-redux';
import { priceImprovementBlotterPageChanged } from 'state/blotters/priceImprovement';
import { getPaginationInfo } from 'state/blotters/priceImprovement/priceImprovementBlotter.selector';
import { priceImprovementBlotterItemsPerPageChangedThunk } from 'state/blotters/priceImprovement/priceImprovementBlotter.thunk';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export const mapStateToProps = (state: AppState): PaginationStateProps => {
  const { page, totalPages, totalItems, itemsPerPage } = getPaginationInfo(state);
  return {
    page,
    itemsPerPage,
    totalItems,
    totalPages,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): PaginationDispatchProps => ({
  onSizeChanged(size) {
    dispatch(priceImprovementBlotterItemsPerPageChangedThunk(size));
  },
  onPageChanged(page: number) {
    dispatch(priceImprovementBlotterPageChanged(page));
  },
});

export const connectPaginationComponent = connect(mapStateToProps, mapDispatchToProps);
